import React from "react"
import { useTranslation } from "react-i18next"
import ApiConnectorCard from "../ApiConnectorCard"
import gcpLogo from "assets/images/connectors/gcp-logo.svg"

/**
 * GCP card for the developer portal
 * Redirects to GCP documentation for configuration
 */
const GCPCard = () => {
  const { t } = useTranslation()

  return (
    <ApiConnectorCard
      serviceName={t("developer_portal:connectors.gcp.name")}
      description={t("developer_portal:connectors.gcp.description")}
      tag={t("developer_portal:connectors.gcp.tag")}
      documentationUrl={t("developer_portal:connectors.gcp.documentation_url")}
      logoSource={gcpLogo}
      logoAlt="GCP"
    />
  )
}

export default GCPCard
